const SESSION_KEY = 'bottom_right_popup_displayed';

export const bottomRightPopupSession = {
    markAsDisplayed: (id: string) => sessionStorage.setItem(SESSION_KEY, id),
    wasAnotherPopupDisplayed: (id: string) => {
        const displayed = sessionStorage.getItem(SESSION_KEY);
        return displayed !== null && displayed !== id;
    },
};
